// src/components/PlanLabel.tsx
"use client";

type PlanLabelProps = {
  nazeka_member?: boolean;
  user_plan?: string | null;
  trialActive?: boolean;
  fullAccessUntil?: string | Date | { toDate?: () => Date } | { _seconds?: number } | null;
  trialEnd?: string | null;
  variant?: "inline" | "sidebar";
  accessSource?: string | null;
};

export default function PlanLabel({
  user_plan,
  trialActive,
  trialEnd,
  fullAccessUntil,
  variant = "inline",
  accessSource,
}: PlanLabelProps) {
  const showTrial = !!trialActive && !!trialEnd;
  const fullAccessMs =
    fullAccessUntil && typeof (fullAccessUntil as any)?.toDate === "function"
      ? (fullAccessUntil as any).toDate().getTime()
      : typeof (fullAccessUntil as any)?._seconds === "number"
      ? (fullAccessUntil as any)._seconds * 1000
      : fullAccessUntil
      ? new Date(fullAccessUntil as any).getTime()
      : 0;
  const fullAccessActive = !!fullAccessMs && fullAccessMs > Date.now();

  const planLabel = showTrial
    ? "トライアル中"
    : fullAccessActive && user_plan === "free" && accessSource === "annual"
    ? "ディスカバリー（年間）"
    : fullAccessActive && user_plan === "free"
    ? "ディスカバリー（体験中）"
    : user_plan === "discovery"
    ? "ディスカバリー"
    : user_plan === "discovery_pro"
    ? "ディスカバリー Pro"
    : user_plan === "facilitator"
    ? "ファシリテーター"
    : user_plan === "partner"
    ? "パートナー"
    : user_plan === "free"
    ? "無料プラン"
    : "";

  return (
    <span
      className={`text-sm ${
        variant === "sidebar" ? "font-normal text-gray-700" : "font-medium text-gray-800"
      }`}
    >
      {planLabel}
    </span>
  );
}
